import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Marks an <ng-template ptlCell="columnKey"> whose content renders the cell for
 * that column in <ptl-data-table>. The template context exposes the row as both
 * `$implicit` and `row`, e.g. `<ng-template ptlCell="name" let-row>`.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- design-system attribute API (ptlCell), not an app 'og' directive
  selector: 'ng-template[ptlCell]',
})
export class PtlTableCellDirective {
  @Input('ptlCell') column!: string;

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  constructor(public readonly template: TemplateRef<{ $implicit: any; row: any }>) {}
}
